import React from 'react';

import StatusPanel from '../StatusPanel';

interface IAgentExportProps {
  visible: boolean;
  loading?: boolean;
  onClose?: () => void;
}

const AgentExport: React.FC<IAgentExportProps> = ({ visible, loading, onClose }) => {
  return <StatusPanel.LoadingPanel group="Agent: Export" loading={loading} visible={visible} onClose={onClose} />;
};

export default AgentExport;
